export default __webpack_public_path__ + "static/kv-sub-ttl-e8e7b00bea9ac17bde4bda830609751c.png";